import { Main } from './GridLayout.style';

const GridLayout = ({ children, indented, component = 'main', className }) => {
  return (
    <Main as={component} $indented={indented} className={className}>
      {children}
    </Main>
  );
};

export default GridLayout;
